import { Stack, Title, Text } from '@repletoryreach/sdk-ui';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '@repletoryreach/sdk-auth';
import { VerifyForm } from './components/VerifyForm';
import { useT } from '../../../i18n/I18nProvider';

export default function VerifyEmailPage() {
  const t = useT();
  const { user } = useAuth();
  const [params] = useSearchParams();
  const sentTo = params.get('email') ?? user?.email ?? '';
  return (
    <Stack gap="lg">
      <Stack gap="xs">
        <Title order={1}>{t('auth.verify.title')}</Title>
        <Text role="bodySmall" c="var(--rr-color-text-muted)">
          {t('auth.verify.description')}
        </Text>
        {/* Nothing told the user which address the code went to; the onboarding
            wizard already had this sentence and its key. */}
        {sentTo && (
          <Text role="bodySmall" c="var(--rr-color-text-muted)">
            {t('onboarding.steps.verify.sentTo', { email: sentTo })}
          </Text>
        )}
      </Stack>
      <VerifyForm
        initialEmail={params.get('email') ?? ''}
        initialCode={params.get('code') ?? ''}
      />
      {/* Linked to `/` even when signed out, which bounced through RequireAuth
          to the login page (auth-verify-email.md §4 item 8). */}
      <Text role="caption" c="var(--rr-color-text-muted)">
        {user
          ? <Link to="/">{t('auth.verify.backToDashboard')}</Link>
          : <Link to="/auth/login">{t('auth.common.backToSignIn')}</Link>}
      </Text>
    </Stack>
  );
}
